import React from "react";
import PageTransition from "../../Components/PageTransition";

export default function Accessories() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <dotlottie-wc
        autoplay
        loop
        src="https://lottie.host/5d592aff-7539-4f40-af4e-d0e115e10dad/gmrLxwFnDS.lottie"
        style={{ width: "400px", height: "400px" }}
      ></dotlottie-wc>
    </div>
  );
}
